import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Search, Users, LayoutGrid, User } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LanguageContext";

export function BottomNav() {
  const { user } = useAuth();
  const { t } = useLang();
  const loc = useLocation();
  const dash = user && user.role === "employer" ? "/employer" : user && user.role === "admin" ? "/admin" : "/dashboard";

  const items = [
    { to: "/", icon: Home, label: t("home") },
    { to: "/jobs", icon: Search, label: t("nav_find_jobs") },
    { to: "/find-people", icon: Users, label: t("nav_find_people") },
    { to: dash, icon: LayoutGrid, label: t("nav_dashboard") },
    { to: user ? (user.role === "candidate" ? "/profile" : dash) : "/login", icon: User, label: t("nav_profile") },
  ];

  return (
    <nav data-testid="bottom-nav" className="md:hidden fixed bottom-0 inset-x-0 z-50 border-t border-slate-200 bg-white/95 backdrop-blur-xl">
      <div className="grid grid-cols-5">
        {items.map((it) => {
          const active = loc.pathname === it.to;
          const Icon = it.icon;
          return (
            <Link key={it.label + it.to} to={it.to} data-testid={`bottomnav-${it.label}`} className="flex flex-col items-center gap-0.5 py-2.5">
              <Icon className={`h-5 w-5 ${active ? "text-brand-blue" : "text-slate-400"}`} />
              <span className={`text-[10px] font-medium ${active ? "text-brand-blue" : "text-slate-400"}`}>{it.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
